<template>
  <div class="news-list" :class="{ no_border: noBorder }">
    <div class="list_title">
      <div class="title_box">
        <img src="@/assets/images/news.png" class="list_title_img" />
        <div class="list_title_text">新闻动态</div>
      </div>
    </div>
    <ul class="content-box">
      <li v-for="(item, index) in listData.slice(0, 4)" :key="index">
        <a :href="item.titleurl ? item.titleurl : `${context}/frontend/showNews.html?hashcode=${item.hashcode}`"
          target="_blank" v-if="index === 0" class="first" @mouseover="f(item.title)" @mouseleave="h()">
          <div class="first-header">
            <img :src="item.picture" alt="">
            <div class="first-title">{{ item.title }}</div>
          </div>
          <div class="first-content">{{ item.secondtitle }}</div>
        </a>
        <a v-else :href="item.titleurl ? item.titleurl : `${context}/frontend/showNews.html?hashcode=${item.hashcode}`"
          target="_blank" :class="{ isRed: item.redtitle == '是' }" @mouseover="f(item.title)" @mouseleave="h()">
          <span class="news_title">{{ item.title }}</span>
          <span class="news_time">{{ item.publishTime | formaTime(showYear) }}</span>
        </a>
      </li>
    </ul>
    <p class="more"><a :href="getHref(menu)">+more</a></p>
  </div>
</template>

<script>
import { getHref } from '@/utils';
export default {
  props: ['listData', 'menu'],
  filters: {
    formaTime: function (value, showYear = false) {
      let time = value.split('-');
      if (showYear) {
        return time[0] + '-' + time[1] + '-' + time[2];
      }
      return time[1] + '-' + time[2];
    },
    getDay: function (value) {
      let time = value.split('-');
      return time[2];
    },
    getMoth: function (value) {
      let time = value.split('-');
      return time[0] + '-' + time[1];
    },
    newsContent: function (value) {
      let div = document.createElement('div');
      div.innerHTML = value;
      return div.innerText.trim();
    },
  },
  methods: {
    getHref,
    f(str){
        let full=document.getElementById("fullTitleShow")
        if(full==null){
            full=document.createElement('div');
            full.id="fullTitleShow"
            full.innerHTML=str
            full.style.position="absolute"
            full.style.left=window.event.pageX+"px"
            full.style.top=window.event.pageY+"px"
            full.style.backgroundColor="white"
            full.style.padding="10px"
            full.style.border="1px solid black"
            full.style.zIndex=10000
            document.body.appendChild(full);
        }
    },
    h(){
        let full=document.getElementById("fullTitleShow")
        if(full!=null){
            document.body.removeChild(full)
        }
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variable.scss';

.news-list {
  .list_title {
    height: 36px;
    margin: 12px 12px 0;
    border-bottom: 2px solid #ccc;
    position: relative;
    display: flex;
    flex-direction: row;

    .title_box {
      height: 36px;
      border-bottom: 2px solid $text_theme_color;
      display: flex;
      flex-direction: row;
      align-items: center;

      .list_title_text {
        color: $text_theme_color;
        font-size: 16px;
        font-weight: 600;
        margin-right: 6px;
      }

      .list_title_img {
        width: 16px;
        height: 16px;
        margin: 0 6px;
      }
    }
  }

  .content-box {
    padding: 16px 16px 8px 16px;
    cursor: pointer;

    .first {
      display: block;

      .first-header {
        display: flex;
        width: 100%;
        height: 100px;

        img {
          width: 140px;
        }

        .first-title {
          @include overLine(4);
          width: 1px;
          flex: 1;
          margin-left: 12px;
          line-height: 26px;
          font-size: 14px;
          font-weight: 600;
        }
      }

      .first-content {
        @include overLine(2);
        height: 56px;
        font-size: 12px !important;
        font-family: Arial, 微软雅黑, Helvetica, sans-serif !important;
        color: #888;
        margin: 0;
        margin-top: 0;
        margin-bottom: 0;
        line-height: 28px;
      }
    }

    .news_box {
      margin-left: 70px;
      font-size: 14px;

      div {
        @include overLine(1);
        color: #333;
        font-weight: 700;
      }

      p {
        margin-top: 3px;
        color: #666;
        @include overLine(2);
        max-height: 30px;
        overflow: hidden;
      }
    }

    .news_box:hover {
      a {
        color: $text_theme_color;
      }
    }
  }

  ul {
    padding: 0 10px;

    li {
      a {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        padding: 8px 0;
        color: #333;

        .news_title {
          @include overLine(1);
          font-size: 14px;
          width: 80%;

          &:before {
            display: inline-block;
            width: 6px;
            height: 6px;
            border-radius: 6px;
            margin-right: 5px;
            /* margin-top: -5px; */
            content: '';
            background: $text_theme_color;
            transform: scale(0.8);
          }
        }

        .news_time {
          width: 14%;
          font-size: 14px;
          align-self: flex-end;
          text-align: end;
        }

        &:hover {
          color: $text_theme_color;
        }
      }
    }
  }
}

.no_border {
  box-shadow: none;
  border-bottom: none;
}

.isRed {
  color: $text_theme_color !important;

  span {
    color: $text_theme_color !important;
  }
}

.more {
  text-align: right;
  font-size: 14px;
  padding-right: 10px;
  cursor: pointer;

  // font-weight: bold;
  &.top {
    position: absolute;
    top: 165px;
    right: 0px;
  }

  a {
    color: $text_theme_color !important;
  }
}
</style>
<style lang="scss">
.content-box {
  .first {
    .first-content {
      p, span {
        font-size: 12px !important;
        font-family: Arial, 微软雅黑, Helvetica, sans-serif !important;
        color: #888;
        margin: 0;
        margin-top: 0;
        margin-bottom: 0;
        line-height: 28px;
      }

    }
  }
}</style>



// WEBPACK FOOTER //
// src/components/news/index.vue